// Canonical industry list used across Orbit (AutoSubmit, Clients, etc.)
export const INDUSTRIES = [
  'Accounting / Tax',
  'Adult Entertainment',
  'Advertising / Marketing / Consulting',
  'Agriculture / Farming / Natural Resources',
  'Auto Sales / Auto Rental',
  'Auto Repair / Collision / Tire',
  'Banking / Financial Services',
  'Beauty Salon / Barber Shop / Spa',
  'Cannabis',
  'Casino / Gambling',
  'Church / Religious Organization',
  'Construction / Contractor',
  'Credit Repair / Debt Settlement / Collections',
  'Distributor / Wholesale',
  'E-Commerce / Online Retailer',
  'Education / Childcare',
  'Entertainment / Music',
  'Factoring',
  'Firearms / Weapons',
  'Fitness / Gym',
  'Gas Station / Convenience Store',
  'General Retail',
  'Hospitality / Hotel / Lodging',
  'HVAC / Plumbing / Landscaping / Electrical',
  'Import / Export',
  'Insurance',
  'IT / Technology / SaaS',
  'Janitorial / Cleaning Services',
  'Law Firm / Attorney',
  'Logistics',
  'Manufacturing',
  'Medical / Healthcare / Dental',
  'Non-Profit',
  'Pest Control',
  'Professional Services',
  'Property Management',
  'Real Estate',
  'Restaurant / Food Services',
  'Security Services',
  'Solar',
  'Specialty Contractors / Home Improvement',
  'Staffing Agency',
  'Tobacco / Smoke Shop',
  'Towing',
  'Transportation / Trucking',
  'Veterinary / Animal Services',
  'Warehousing',
  'Waste Management / Recycling',
  'Other',
];
